import { render } from "./LocalizationEditor.vue?vue&type=template&id=56468f6a"
import script from "./LocalizationEditor.vue?vue&type=script&lang=js"
export * from "./LocalizationEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__